import React from "react";
import { Link } from "react-router-dom";
import '../style.css'

const Footer = () => {
  return (
    <>
    
    <div>

    <footer className="footer">
      <div className="footer-container">
        <div className="footer-about">
          <h3 style={{color:'#37b8ab'}}>About Us</h3>
          <p>
            In 2017, Shri Shiva Ganga Group was started as a project to counter imperfections in the preschool space. With more than 500 happy, “future-ready kids” and counting...
          </p>
        </div>

        <div className="footer-links">
          <h3 style={{color:'#37b8ab'}}>Main Links</h3>
          <ul>
            <Link to="/" style={{textDecoration:'none',color:'#fff'}}><li>Home</li></Link>
            <Link to="/about" style={{textDecoration:'none',color:'#fff'}}><li>About Us</li></Link>
            <Link to="/ourprograms" style={{textDecoration:'none',color:'#fff'}}><li>Programs</li></Link>
            {/* <Link to="/"><li>Gallery</li></Link> */}
            <Link to="/contact" style={{textDecoration:'none',color:'#fff'}}><li>Contact Us</li></Link>
          </ul>
        </div>

        <div className="footer-contact">
          <h3 style={{color:'#37b8ab'}}>Contact Us</h3>
          <p  >
          Shri Shiva Ganga Group<br />
          Rock Town Residents Colony, Mannava Enclave, Chanakyapuri, Hyderabad, Telangana 500068<br />
          </p>
          <p >
            +91 9281042708<br />
            info@shivagangagroup.com
          </p>
        </div>
      </div>
      <div className="footer-copyright">
        © Copyright <a href="https://learnorama.in/" style={{textDecoration:'none',color:'#37b8ab'}}>Learnorama</a> 2024. All Rights Reserved.
      </div>
    </footer>

    </div>
    
    </>
  );
};

export default Footer;
